import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export async function joinWaitlist(payload) {
  const { data } = await api.post("/waitlist", payload);
  return data;
}

export async function createDoctorRequest(payload) {
  const { data } = await api.post("/doctor-requests", payload);
  return data;
}

export async function fetchStories() {
  const { data } = await api.get("/stories");
  return data;
}

export async function fetchStory(slug) {
  const { data } = await api.get(`/stories/${slug}`);
  return data;
}

const chatApi = axios.create({
  baseURL: `${API}/chat`,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
  timeout: 70000,
});

export async function startChat() {
  const { data } = await chatApi.post("/start");
  return data;
}

export async function askChat(question) {
  const { data } = await chatApi.post("/ask", { question });
  return data;
}
